import { ExamScheduleConfig, ExamQuestion } from '../types/exam';

export const MOCK_TEST_1_QUESTIONS: ExamQuestion[] = [
  {
    "id": 1,
    "category": "Athletics Administration",
    "text": "According to official athletics curriculum, where is the headquarters of the Asian Athletics Association (AAA) located?",
    "options": [
      "Tokyo, Japan",
      "Singapore",
      "New Delhi, India",
      "Kuala Lumpur, Malaysia"
    ],
    "correctOption": 1,
    "explanation": "The Asian Athletics Association (AAA) is headquartered in Singapore."
  },
  {
    "id": 2,
    "category": "Nutrition",
    "text": "What is the standard caloric energy value provided by 1 gram of carbohydrate in human nutrition?",
    "options": [
      "2.0 Kcal",
      "4.1 Kcal",
      "7.0 Kcal",
      "9.1 Kcal"
    ],
    "correctOption": 1,
    "explanation": "1 gram of carbohydrate provides 4.1 Kcal of energy, identical to the standard energy yield of proteins."
  },
  {
    "id": 3,
    "category": "Shot Put",
    "text": "What is the official diameter of the throwing circle in Shot Put?",
    "options": [
      "2.500 m",
      "2.135 m",
      "1.800 m",
      "2.000 m"
    ],
    "correctOption": 1,
    "explanation": "The Shot Put circle has an inner diameter of 2.135 meters (7 feet) with a 6mm rim."
  },
  {
    "id": 4,
    "category": "Shot Put",
    "text": "What is the official competition weight of the Shot for Men in senior track and field events?",
    "options": [
      "5.000 kg",
      "6.000 kg",
      "7.260 kg",
      "8.000 kg"
    ],
    "correctOption": 2,
    "explanation": "The Men's shot weight is 7.260 kg (16 lbs), with circumference between 110mm and 130mm."
  },
  {
    "id": 5,
    "category": "Discus Throw",
    "text": "What is the interior diameter of the throwing circle used in Discus Throw?",
    "options": [
      "2.135 m",
      "2.250 m",
      "2.500 m",
      "2.750 m"
    ],
    "correctOption": 2,
    "explanation": "The Discus Throw circle diameter is 2.50 meters, larger than Shot Put and Hammer circles."
  },
  {
    "id": 6,
    "category": "Throwing Events",
    "text": "What is the official landing sector angle for Shot Put, Discus Throw, and Hammer Throw?",
    "options": [
      "28.96\u00b0",
      "34.92\u00b0",
      "40.00\u00b0",
      "45.00\u00b0"
    ],
    "correctOption": 1,
    "explanation": "The standard landing sector angle for Shot Put, Discus Throw, and Hammer Throw is exactly 34.92\u00b0."
  },
  {
    "id": 7,
    "category": "Javelin Throw",
    "text": "What is the official throwing sector angle for the Javelin Throw?",
    "options": [
      "34.92\u00b0",
      "28.96\u00b0 (approx. 29\u00b0)",
      "40.00\u00b0",
      "25.00\u00b0"
    ],
    "correctOption": 1,
    "explanation": "The Javelin sector has an angle of 28.96 degrees (commonly marked at 29 degrees)."
  },
  {
    "id": 8,
    "category": "Javelin Throw",
    "text": "What are the official weights of the Javelin for Men and Women competitors respectively?",
    "options": [
      "Men 700g, Women 500g",
      "Men 800g, Women 600g",
      "Men 850g, Women 650g",
      "Men 900g, Women 700g"
    ],
    "correctOption": 1,
    "explanation": "The official weight of the javelin is 800 grams for men and 600 grams for women."
  },
  {
    "id": 9,
    "category": "High Jump",
    "text": "Which revolutionary jumping technique was introduced by Dick Fosbury at the 1968 Olympic Games?",
    "options": [
      "The Scissors jump",
      "The Western Roll",
      "The Fosbury Flop",
      "The Straddle technique"
    ],
    "correctOption": 2,
    "explanation": "Dick Fosbury popularized the Fosbury Flop technique (jumping backward over the bar), which became the international standard."
  },
  {
    "id": 10,
    "category": "High Jump",
    "text": "What are the minimum required dimensions of the cushioned landing mats in the High Jump?",
    "options": [
      "4m long x 2m wide x 0.5m thick",
      "5m long x 3m wide x 0.7m thick",
      "6m long x 3m wide x 0.4m thick",
      "5m long x 4m wide x 1.0m thick"
    ],
    "correctOption": 1,
    "explanation": "The landing mats must measure at least 5 meters in length, 3 meters in width, and 0.7 meters in thickness."
  },
  {
    "id": 11,
    "category": "Long Jump",
    "text": "What are the official dimensions of the Long Jump take-off board?",
    "options": [
      "1.00m long, 15cm wide, 5cm thick",
      "1.22m long, 20cm wide, 10cm thick",
      "1.25m long, 25cm wide, 10cm thick",
      "1.50m long, 20cm wide, 8cm thick"
    ],
    "correctOption": 1,
    "explanation": "The take-off board is 1.22 meters long, 20 cm wide (0.20m), and 10 cm thick, painted white."
  },
  {
    "id": 12,
    "category": "Long Jump",
    "text": "What are the standard dimensions of the damp sand landing pit in Long Jump?",
    "options": [
      "Length 7m, Width 2.0m, Depth 30cm",
      "Length 9m, Width 2.75m to 3.0m, Depth 50cm",
      "Length 11m, Width 3.5m, Depth 60cm",
      "Length 8m, Width 2.5m, Depth 40cm"
    ],
    "correctOption": 1,
    "explanation": "The landing pit is 9 meters long, 2.75m to 3.0m wide, and approximately 50 cm in depth."
  },
  {
    "id": 13,
    "category": "Triple Jump",
    "text": "In Triple Jump, what is the exact mandatory sequence of phases required for a fair jump?",
    "options": [
      "Jump, Step, Hop",
      "Hop, Step, and Jump",
      "Step, Hop, and Jump",
      "Hop, Hop, and Jump"
    ],
    "correctOption": 1,
    "explanation": "The triple jump must be executed strictly as a Hop, a Step, and a Jump in that exact order."
  },
  {
    "id": 14,
    "category": "Triple Jump",
    "text": "During the Hop phase of Triple Jump, on which foot must the athlete land before executing the Step?",
    "options": [
      "The opposite foot",
      "The same foot that initiated take-off",
      "Both feet simultaneously",
      "Any foot at the athlete's choice"
    ],
    "correctOption": 1,
    "explanation": "The rule mandates that the hop must be landed on the same foot used for take-off, followed by the step taken on the opposite foot."
  },
  {
    "id": 15,
    "category": "Triple Jump",
    "text": "In international competitions, what is the standard distance of the take-off board from the landing pit for Men?",
    "options": [
      "9 meters",
      "11 meters",
      "13 meters",
      "15 meters"
    ],
    "correctOption": 2,
    "explanation": "The take-off line is placed 13 meters from the sand pit for men (and 11 meters for women)."
  },
  {
    "id": 16,
    "category": "Yoga",
    "text": "The English term 'Yoga' originates from which Sanskrit root word, and what does it literally mean?",
    "options": [
      "'Yuj' meaning to join, yoke, or unite",
      "'Yuga' meaning era or age",
      "'Yatna' meaning effort or struggle",
      "'Yukti' meaning tactic or device"
    ],
    "correctOption": 0,
    "explanation": "Yoga is derived from the Sanskrit root 'Yuj', which means 'to join', 'to yoke', or 'to unite' individual consciousness with universal consciousness."
  },
  {
    "id": 17,
    "category": "Yoga",
    "text": "Who is universally celebrated as the compiler of the Yoga Sutras and the Father of Classical Yoga?",
    "options": [
      "Maharishi Patanjali",
      "Swami Vivekananda",
      "Adi Shankaracharya",
      "Sage Veda Vyasa"
    ],
    "correctOption": 0,
    "explanation": "Maharishi Patanjali codified the classical system of Yoga in the Yoga Sutras, famously defining it as 'Yogas Chitta Vritti Nirodhah'."
  },
  {
    "id": 18,
    "category": "Yoga",
    "text": "How many progressive limbs (Angas) constitute the holistic system of Ashtanga Yoga?",
    "options": [
      "Four limbs",
      "Six limbs",
      "Eight limbs",
      "Ten limbs"
    ],
    "correctOption": 2,
    "explanation": "Ashtanga Yoga consists of eight limbs ('Ashta' meaning eight, 'Anga' meaning limb)."
  },
  {
    "id": 19,
    "category": "Yoga",
    "text": "Which of the following is the very first limb of Ashtanga Yoga focusing on universal moral and ethical restraints?",
    "options": [
      "Niyama",
      "Yama",
      "Asana",
      "Pranayama"
    ],
    "correctOption": 1,
    "explanation": "Yama (moral ethics/codes) is the first limb of Ashtanga Yoga, followed by Niyama."
  },
  {
    "id": 20,
    "category": "Yoga",
    "text": "Which of the following observances belongs to the five Niyamas (self-discipline) rather than the five Yamas?",
    "options": [
      "Ahimsa (Non-violence)",
      "Satya (Truthfulness)",
      "Saucha (Purity and cleanliness)",
      "Asteya (Non-stealing)"
    ],
    "correctOption": 2,
    "explanation": "Saucha (Purity/Cleanliness) is the first Niyama. Ahimsa, Satya, and Asteya are Yamas."
  },
  {
    "id": 21,
    "category": "Nutrition",
    "text": "What is the typical elemental ratio of Carbon, Hydrogen, and Oxygen (C : H : O) in carbohydrates?",
    "options": [
      "1 : 1 : 1",
      "1 : 2 : 1",
      "2 : 1 : 2",
      "1 : 3 : 1"
    ],
    "correctOption": 1,
    "explanation": "Carbohydrates follow the general empirical formula (CH2O)n, giving an elemental ratio of C:H:O = 1:2:1."
  },
  {
    "id": 22,
    "category": "Nutrition",
    "text": "Which simple monosaccharide sugar is commonly called 'fruit sugar' and is the sweetest natural sugar?",
    "options": [
      "Glucose",
      "Galactose",
      "Fructose",
      "Maltose"
    ],
    "correctOption": 2,
    "explanation": "Fructose is found naturally in fruits and honey, and is the sweetest tasting natural monosaccharide."
  },
  {
    "id": 23,
    "category": "Nutrition",
    "text": "Which specific biochemical bond unites amino acids into polypeptide protein structures?",
    "options": [
      "Glycosidic bond",
      "Ester bond",
      "Peptide bond",
      "Phosphodiester bond"
    ],
    "correctOption": 2,
    "explanation": "Proteins are formed when amino acids link together via peptide bonds."
  },
  {
    "id": 24,
    "category": "Nutrition",
    "text": "Which clinical disorder results from acute protein deficiency in childhood, characterized by edema, protruding belly, and muscle wasting?",
    "options": [
      "Kwashiorkor",
      "Rickets",
      "Scurvy",
      "Pellagra"
    ],
    "correctOption": 0,
    "explanation": "Kwashiorkor is the classic protein-deficiency disease occurring in young children with inadequate protein intake."
  },
  {
    "id": 25,
    "category": "Track Rules",
    "text": "Under World Athletics rules implemented since 2010, what is the consequence of a false start in sprint races?",
    "options": [
      "One false start allowed per race",
      "Immediate disqualification of the offending runner",
      "Starting 1 meter behind the line",
      "A warning followed by yellow card"
    ],
    "correctOption": 1,
    "explanation": "Under the 2010 rule change, any competitor responsible for a false start is immediately disqualified."
  },
  {
    "id": 26,
    "category": "Track Rules",
    "text": "What is the maximum number of spikes permitted on the sole or heel of an athletics track running shoe?",
    "options": [
      "6 spikes",
      "8 spikes",
      "11 spikes",
      "14 spikes"
    ],
    "correctOption": 2,
    "explanation": "Official rules allow any number of spikes up to 11, but the total number must not exceed 11 spikes."
  },
  {
    "id": 27,
    "category": "Decathlon",
    "text": "The Men's Olympic Decathlon comprises 10 total events divided into how many Track and Field events?",
    "options": [
      "5 Track events and 5 Field events",
      "4 Track events and 6 Field events",
      "6 Track events and 4 Field events",
      "3 Track events and 7 Field events"
    ],
    "correctOption": 1,
    "explanation": "Decathlon consists of 4 Track events (100m, 400m, 110m hurdles, 1500m) and 6 Field events (Long Jump, Shot Put, High Jump, Discus, Pole Vault, Javelin)."
  },
  {
    "id": 28,
    "category": "Decathlon",
    "text": "What is the opening competition event contested on Day 1 of the Men's Decathlon?",
    "options": [
      "Long Jump",
      "Shot Put",
      "100m sprint",
      "400m race"
    ],
    "correctOption": 2,
    "explanation": "Day 1 of Decathlon always begins with the 100m sprint, followed by Long Jump, Shot Put, High Jump, and 400m."
  },
  {
    "id": 29,
    "category": "Pole Vault",
    "text": "In international athletics competitions, what are the minimum dimensions for the Pole Vault landing mat?",
    "options": [
      "5m long x 4m wide x 0.6m high",
      "6m long x 6m wide x 0.8m high",
      "7m long x 5m wide x 0.9m high",
      "8m long x 6m wide x 1.0m high"
    ],
    "correctOption": 1,
    "explanation": "In international competitions, the Pole Vault landing area must not be smaller than 6m long x 6m wide x 0.8m high."
  },
  {
    "id": 30,
    "category": "Hammer Throw",
    "text": "What is the official weight of the implement in Men's senior Hammer Throw?",
    "options": [
      "5.000 kg",
      "6.000 kg",
      "7.260 kg",
      "8.000 kg"
    ],
    "correctOption": 2,
    "explanation": "The Men's hammer weighs 7.260 kg, with a total length of 1175mm to 1215mm from inside of the handle."
  }
];

export const MOCK_TEST_2_QUESTIONS: ExamQuestion[] = [
  {
    "id": 1,
    "category": "Shot Put",
    "text": "What is the official weight of the Shot for Women in senior track and field competitions?",
    "options": [
      "3.000 kg",
      "4.000 kg",
      "4.500 kg",
      "5.000 kg"
    ],
    "correctOption": 1,
    "explanation": "The official weight of the Women's shot is 4.000 kg, with a circumference between 95mm and 110mm."
  },
  {
    "id": 2,
    "category": "Discus Throw",
    "text": "What is the official weight of the Discus for Women in senior athletics competitions?",
    "options": [
      "0.75 kg",
      "1.00 kg",
      "1.50 kg",
      "2.00 kg"
    ],
    "correctOption": 1,
    "explanation": "The Women's discus weighs 1.000 kg (diameter 180-182mm), while the Men's discus weighs 2.000 kg (diameter 219-221mm)."
  },
  {
    "id": 3,
    "category": "Javelin Throw",
    "text": "What are the official weight and overall length of the Women's Javelin?",
    "options": [
      "500g and 2.0 - 2.1m",
      "600g and 2.2 - 2.3m",
      "600g and 2.6 - 2.7m",
      "700g and 2.3 - 2.4m"
    ],
    "correctOption": 1,
    "explanation": "The Women's javelin weighs 600 grams and has an overall length of 2.20 to 2.30 meters."
  },
  {
    "id": 4,
    "category": "Javelin Throw",
    "text": "What are the standard length and width specifications for the Javelin runway?",
    "options": [
      "Length 20-25m, Width 3m",
      "Length 30-36.5m, Width 4m",
      "Length 40-45m, Width 1.22m",
      "Length 50m, Width 5m"
    ],
    "correctOption": 1,
    "explanation": "The javelin runway has a length between 30m and 36.5m, and a width of 4 meters."
  },
  {
    "id": 5,
    "category": "Javelin Throw",
    "text": "According to official rules, how must the Javelin be held and propelled during the throw?",
    "options": [
      "With two hands like a spear",
      "At the grip with one hand only, over the shoulder or upper throwing arm",
      "Slung with a rotational windmill motion",
      "Pushed from beneath the chest level"
    ],
    "correctOption": 1,
    "explanation": "The javelin must be held at the cord grip with one hand only, and thrown over the shoulder or upper part of the throwing arm without slings or non-orthodox styles."
  },
  {
    "id": 6,
    "category": "Javelin Throw",
    "text": "For a Javelin throw to be declared valid and measured, which part of the javelin must strike the ground first?",
    "options": [
      "Any part of the shaft",
      "The cord grip",
      "The metal head/tip",
      "The rear tail of the javelin"
    ],
    "correctOption": 2,
    "explanation": "A throw is valid only if the metal head of the javelin strikes the ground before any other part of the implement."
  },
  {
    "id": 7,
    "category": "Discus Throw",
    "text": "The protective safety cage for Discus Throw must be designed to safely contain a 2kg discus moving at speeds up to:",
    "options": [
      "15 meters per second",
      "20 meters per second",
      "25 meters per second",
      "35 meters per second"
    ],
    "correctOption": 2,
    "explanation": "Discus cages are engineered to stop a 2kg discus moving at velocities up to 25 m/s."
  },
  {
    "id": 8,
    "category": "Hammer Throw",
    "text": "The heavy-duty protective cage in Hammer Throw must be engineered to withstand and stop a 7.260kg hammer moving at speeds up to:",
    "options": [
      "20 meters per second",
      "25 meters per second",
      "32 meters per second",
      "40 meters per second"
    ],
    "correctOption": 2,
    "explanation": "The hammer cage must be capable of stopping a 7.260 kg hammer head traveling at up to 32 meters per second."
  },
  {
    "id": 9,
    "category": "High Jump",
    "text": "What are the official length and maximum weight specifications of the High Jump crossbar?",
    "options": [
      "Length 3.50m, weight 1.5kg",
      "Length 4.00m to 4.04m, weight 2.0kg",
      "Length 4.50m, weight 2.25kg",
      "Length 5.00m, weight 3.0kg"
    ],
    "correctOption": 1,
    "explanation": "The High Jump crossbar measures between 4.00m and 4.04m in length, with a maximum weight of 2.0 kg."
  },
  {
    "id": 10,
    "category": "High Jump",
    "text": "What fundamental rule governs the take-off technique in High Jump?",
    "options": [
      "Athletes can take off from either one or two feet",
      "Take-off must be executed from one foot only",
      "Athletes must perform a handspring before take-off",
      "Both feet must push together from a take-off board"
    ],
    "correctOption": 1,
    "explanation": "Official athletics rules strictly require that high jump take-off must be made from one foot only."
  },
  {
    "id": 11,
    "category": "Long Jump",
    "text": "What is the width of the plasticine foul indicator board placed directly beyond the take-off board in Long Jump?",
    "options": [
      "5 cm",
      "10 cm (100 mm)",
      "15 cm",
      "20 cm"
    ],
    "correctOption": 1,
    "explanation": "The plasticine indicator board is 10 cm wide, positioned immediately after the 20cm take-off board to record foul foot marks."
  },
  {
    "id": 12,
    "category": "Long Jump",
    "text": "Which three primary airborne techniques are universally utilized by competitive long jumpers?",
    "options": [
      "Scissors, Straddle, and Flop",
      "Sail technique, Hang technique, and Hitch-kick",
      "Hop, Step, and Bound",
      "Glide, Spin, and Pitch"
    ],
    "correctOption": 1,
    "explanation": "The three classical in-flight long jump techniques taught in physical education are the Sail, Hang, and Hitch-kick (running in the air)."
  },
  {
    "id": 13,
    "category": "Triple Jump",
    "text": "What is the standard distance from the take-off board to the sand landing pit for Women in international Triple Jump?",
    "options": [
      "9 meters",
      "11 meters",
      "13 meters",
      "15 meters"
    ],
    "correctOption": 1,
    "explanation": "The take-off board distance to the pit for women is 11 meters (compared to 13 meters for men)."
  },
  {
    "id": 14,
    "category": "Shot Put",
    "text": "What are the dimensions of the white curved wooden stop board anchored at the front of the Shot Put circle?",
    "options": [
      "Length 1.00m, Width 10cm, Height 8cm",
      "Length 1.21-1.23m, Width 11.2-13.0cm, Height 9.8-10.2cm",
      "Length 1.50m, Width 15cm, Height 12cm",
      "Length 2.00m, Width 20cm, Height 15cm"
    ],
    "correctOption": 1,
    "explanation": "The stop board is 1.21m to 1.23m in length, 11.2cm to 13.0cm wide, and 9.8cm to 10.2cm high, painted white."
  },
  {
    "id": 15,
    "category": "Shot Put",
    "text": "The linear backward gliding technique popularized by world champion Parry O'Brien is known as the:",
    "options": [
      "Scissors style",
      "Glide technique",
      "Disco spin technique",
      "Fosbury technique"
    ],
    "correctOption": 1,
    "explanation": "Parry O'Brien invented the linear Glide method in the 1950s, dramatically increasing throwing distances."
  },
  {
    "id": 16,
    "category": "Shot Put",
    "text": "What is the modern rotational throwing technique in Shot Put commonly referred to in competitive coaching?",
    "options": [
      "Western Roll",
      "Rotational / Disco Put style",
      "Hitch-kick Put",
      "Orthodox Stride"
    ],
    "correctOption": 1,
    "explanation": "The rotational style in Shot Put is known as the Rotatory / Disco Put / Spin technique, borrowing movement mechanics from discus throw."
  },
  {
    "id": 17,
    "category": "Nutrition",
    "text": "How many Kcal of energy is provided by the metabolic oxidation of 1 gram of dietary Fat?",
    "options": [
      "4.1 Kcal",
      "7.0 Kcal",
      "9.1 Kcal",
      "12.5 Kcal"
    ],
    "correctOption": 2,
    "explanation": "Dietary fat provides 9.1 Kcal per gram, which is more than double the energy density of carbohydrates or proteins (4.1 Kcal/g)."
  },
  {
    "id": 18,
    "category": "Nutrition",
    "text": "Triglycerides and dietary fats are chemically composed of fatty acids linked to glycerol through which bond?",
    "options": [
      "Peptide bonds",
      "Ester bonds",
      "Glycosidic bonds",
      "Disulfide bridges"
    ],
    "correctOption": 1,
    "explanation": "Fat molecules consist of glycerol joined to fatty acid chains via ester linkages."
  },
  {
    "id": 19,
    "category": "Nutrition",
    "text": "Which type of dietary fat contains one or more carbon-to-carbon double bonds and supports beneficial HDL cholesterol?",
    "options": [
      "Saturated fatty acids",
      "Unsaturated fatty acids",
      "Trans fatty acids",
      "Hydrogenated fats"
    ],
    "correctOption": 1,
    "explanation": "Unsaturated fats (such as Omega-3 and Omega-6 polyunsaturated fatty acids) have double bonds, remain liquid at room temperature, and support HDL cholesterol."
  },
  {
    "id": 20,
    "category": "Nutrition",
    "text": "How many of the 20 standard dietary amino acids are classified as 'Essential' because the human body cannot synthesize them?",
    "options": [
      "5 amino acids",
      "9 amino acids",
      "11 amino acids",
      "15 amino acids"
    ],
    "correctOption": 1,
    "explanation": "There are 9 essential amino acids (Leucine, Isoleucine, Lysine, Methionine, Phenylalanine, Threonine, Tryptophan, Valine, Histidine) and 11 non-essential."
  },
  {
    "id": 21,
    "category": "Nutrition",
    "text": "Which common disaccharide sugar is found in milk and consists of one unit of Glucose combined with one unit of Galactose?",
    "options": [
      "Sucrose",
      "Maltose",
      "Lactose",
      "Cellulose"
    ],
    "correctOption": 2,
    "explanation": "Lactose (milk sugar) is a disaccharide made of Glucose + Galactose. Sucrose is Glucose + Fructose, and Maltose is Glucose + Glucose."
  },
  {
    "id": 22,
    "category": "Yoga",
    "text": "What is the second limb of Ashtanga Yoga, which encompasses positive self-discipline and personal observances?",
    "options": [
      "Asana",
      "Niyama",
      "Dharana",
      "Samadhi"
    ],
    "correctOption": 1,
    "explanation": "Niyama is the second limb of Ashtanga Yoga, establishing rules of personal discipline and purity."
  },
  {
    "id": 23,
    "category": "Yoga",
    "text": "In Ashtanga Yoga philosophy, which of the following represents the 5th Niyama meaning surrender to the Divine?",
    "options": [
      "Santosha",
      "Tapas",
      "Svadhyaya",
      "Ishvara Pranidhana"
    ],
    "correctOption": 3,
    "explanation": "The 5 Niyamas are Saucha (cleanliness), Santosha (contentment), Tapas (discipline), Svadhyaya (self-study), and Ishvara Pranidhana (surrender to the divine)."
  },
  {
    "id": 24,
    "category": "Yoga",
    "text": "The Sanskrit word 'Asana' literally translates to:",
    "options": [
      "Movement",
      "Seat or posture",
      "Breath",
      "Meditation"
    ],
    "correctOption": 1,
    "explanation": "Asana literally means a 'seat'\u2014defined by Patanjali as 'Sthira Sukham Asanam' (steady and comfortable posture)."
  },
  {
    "id": 25,
    "category": "Yoga",
    "text": "In Pranayama practice, what are the three systematic stages of breath regulation?",
    "options": [
      "Agni, Vayu, and Jala",
      "Puraka (Inhalation), Kumbhaka (Retention), and Rechaka (Exhalation)",
      "Yama, Niyama, and Samadhi",
      "Ida, Pingala, and Sushumna"
    ],
    "correctOption": 1,
    "explanation": "The three components of Pranayama are Puraka (inhalation), Kumbhaka (breath retention), and Rechaka (exhalation)."
  },
  {
    "id": 26,
    "category": "Heptathlon",
    "text": "The Women's Olympic Heptathlon consists of 7 total events over 2 days. How are they divided between track and field?",
    "options": [
      "4 Track and 3 Field events",
      "3 Track and 4 Field events",
      "2 Track and 5 Field events",
      "5 Track and 2 Field events"
    ],
    "correctOption": 1,
    "explanation": "Women's Heptathlon features 3 Track events (100m hurdles, 200m, 800m) and 4 Field events (High Jump, Shot Put, Long Jump, Javelin)."
  },
  {
    "id": 27,
    "category": "Heptathlon",
    "text": "Which four events are contested in order on Day 1 of the Women's Heptathlon?",
    "options": [
      "100m hurdles, High Jump, Shot Put, and 200m race",
      "100m sprint, Long Jump, Javelin, and 800m race",
      "200m race, Shot Put, Pole Vault, and 100m hurdles",
      "Long Jump, High Jump, 400m race, and Shot Put"
    ],
    "correctOption": 0,
    "explanation": "Day 1 of Heptathlon includes: 1) 100m Hurdles, 2) High Jump, 3) Shot Put, and 4) 200m race."
  },
  {
    "id": 28,
    "category": "Track Rules",
    "text": "What is the standard width of the white demarcation lines that separate running lanes on an athletic track?",
    "options": [
      "2.5 cm",
      "5.0 cm",
      "7.5 cm",
      "10.0 cm"
    ],
    "correctOption": 1,
    "explanation": "Track lane lines and start/finish boundary lines are standard 5 cm wide white lines."
  },
  {
    "id": 29,
    "category": "Track Rules",
    "text": "In track and field competitions, what does a Green Card displayed by the starter or referee indicate?",
    "options": [
      "The athlete is disqualified",
      "A warning for misconduct",
      "A technical/equipment malfunction occurred and no athlete is penalized",
      "Permission to start before others"
    ],
    "correctOption": 2,
    "explanation": "A Green Card signifies a technical false start or equipment error where no athlete is assessed a foul or penalty."
  },
  {
    "id": 30,
    "category": "Track Rules",
    "text": "What is the mandatory minimum rest interval required between two successive rounds of sprint events up to 200 meters?",
    "options": [
      "20 minutes",
      "45 minutes",
      "90 minutes",
      "120 minutes"
    ],
    "correctOption": 1,
    "explanation": "Official rules require at least 45 minutes between rounds for races up to 200m, and 90 minutes for races between 200m and 10,000m."
  }
];

export const FINAL_EXAM_50_QUESTIONS: ExamQuestion[] = [
  {
    id: 1,
    category: "Athletics - Decathlon",
    text: "In the men's Decathlon, how many of the 10 events are field events?",
    options: ["4", "5", "6", "7"],
    correctOption: 2,
    explanation: "6 – The other 4 are track events (100m, 400m, 110m hurdles, 1500m)."
  },
  {
    id: 2,
    category: "Athletics - Heptathlon",
    text: "Which events are held on the 2nd day of the Heptathlon?",
    options: [
      "100m Hurdles, High Jump, Shot Put",
      "Long Jump, Javelin Throw, 800m",
      "200m, Long Jump, Shot Put",
      "High Jump, Javelin Throw, 400m"
    ],
    correctOption: 1,
    explanation: "Long Jump, Javelin Throw, 800m are contested on Day 2 of the Women's Heptathlon."
  },
  {
    id: 3,
    category: "Athletics - Track Events",
    text: "What is the official distance of a marathon?",
    options: ["40.195 km", "42.000 km", "42.195 km", "44.195 km"],
    correctOption: 2,
    explanation: "The official marathon distance is 42.195 km (26 miles 385 yards)."
  },
  {
    id: 4,
    category: "Athletics - Track Rules",
    text: "An athlete leaves the mark after the word \"Set\" but before the pistol is fired. Under the rules since 2010, outside combined events, the athlete is:",
    options: [
      "Given a warning",
      "Shown a green card",
      "Disqualified",
      "Allowed to restart from 1 m behind"
    ],
    correctOption: 2,
    explanation: "Disqualified – This is a false start, also called 'Beating the Pistol'."
  },
  {
    id: 5,
    category: "Athletics - Equipment",
    text: "What is the maximum number of spikes allowed on a track shoe?",
    options: ["9", "10", "11", "12"],
    correctOption: 2,
    explanation: "The maximum number of spikes permitted on a competition track shoe is 11."
  },
  {
    id: 6,
    category: "Athletics - Track Rules",
    text: "What is the minimum time between two rounds of races up to and including 200m?",
    options: ["30 minutes", "45 minutes", "60 minutes", "90 minutes"],
    correctOption: 1,
    explanation: "Under official athletics regulations, at least 45 minutes must elapse between rounds for races up to and including 200m."
  },
  {
    id: 7,
    category: "Athletics - Officiating",
    text: "In track and field, a green card is shown when:",
    options: [
      "An athlete is warned",
      "An athlete is disqualified",
      "There is a technical fault and no athlete is punished",
      "An athlete leaves the track voluntarily"
    ],
    correctOption: 2,
    explanation: "There is a technical fault and no athlete is punished."
  },
  {
    id: 8,
    category: "Long Jump",
    text: "What are the dimensions of the take-off board in long jump?",
    options: [
      "1.22 m × 0.10 m × 0.20 m",
      "1.22 m × 0.20 m × 0.10 m",
      "1.20 m × 0.22 m × 0.10 m",
      "1.25 m × 0.20 m × 0.07 m"
    ],
    correctOption: 1,
    explanation: "1.22 m × 0.20 m × 0.10 m – 1.22 m long × 0.20 m wide × 0.10 m thick."
  },
  {
    id: 9,
    category: "Long Jump",
    text: "How high is the plasticine indicator board?",
    options: ["5 mm", "7 mm", "10 mm", "20 mm"],
    correctOption: 1,
    explanation: "The plasticine indicator board stands 7 mm high above the take-off board."
  },
  {
    id: 10,
    category: "Long Jump",
    text: "In long jump, the wind gauge is placed how far from the take-off board?",
    options: ["10 m", "15 m", "20 m", "40 m"],
    correctOption: 2,
    explanation: "In long jump, the wind gauge is situated 20 m from the take-off board."
  },
  {
    id: 11,
    category: "Long Jump",
    text: "Which of the following is NOT a flight style in long jump?",
    options: ["Sail style", "Hang style", "Hitch kick", "Fosbury flop"],
    correctOption: 3,
    explanation: "Fosbury flop – It is a high jump technique, not a long jump style."
  },
  {
    id: 12,
    category: "Triple Jump",
    text: "In the \"hop\" phase of the triple jump, the athlete:",
    options: [
      "Takes off from one foot and lands on the opposite foot",
      "Takes off from one foot and lands on the same foot",
      "Takes off from both feet",
      "Lands directly in the sand pit"
    ],
    correctOption: 1,
    explanation: "Takes off from one foot and lands on the same foot."
  },
  {
    id: 13,
    category: "Triple Jump",
    text: "What is the correct sequence of phases in the triple jump?",
    options: [
      "Step – Hop – Jump",
      "Hop – Jump – Step",
      "Hop – Step – Jump",
      "Jump – Hop – Step"
    ],
    correctOption: 2,
    explanation: "Hop – Step – Jump is the mandatory chronological sequence in triple jump."
  },
  {
    id: 14,
    category: "Triple Jump",
    text: "How is a triple jump measured?",
    options: [
      "From the plasticine board to the farthest mark",
      "Perpendicular from the take-off line to the nearest mark in the sand",
      "From the end of the runway to the heel mark",
      "Diagonally from the take-off board to the landing point"
    ],
    correctOption: 1,
    explanation: "Perpendicular from the take-off line to the nearest mark in the sand."
  },
  {
    id: 15,
    category: "High Jump",
    text: "In which high jump style does the athlete's back face the bar, with a curved approach run?",
    options: ["Western Roll", "Eastern Roll", "Scissors Jump", "Fosbury Flop"],
    correctOption: 3,
    explanation: "Fosbury Flop."
  },
  {
    id: 16,
    category: "High Jump",
    text: "How many attempts does an athlete get to clear a particular height in high jump?",
    options: ["1", "2", "3", "6"],
    correctOption: 2,
    explanation: "3 attempts are allowed at each successive bar height."
  },
  {
    id: 17,
    category: "High Jump",
    text: "Which high jump technique is among the earliest, is often used in training, and involves landing on the feet?",
    options: ["Straddle", "Scissors Jump", "Western Roll", "Fosbury Flop"],
    correctOption: 1,
    explanation: "Scissors Jump allows the athlete to clear the bar and land upright on their feet."
  },
  {
    id: 18,
    category: "High Jump",
    text: "What is the minimum size of the high jump landing mat?",
    options: ["4 m × 2 m", "5 m × 3 m", "6 m × 6 m", "9 m × 2.75 m"],
    correctOption: 1,
    explanation: "5 m × 3 m is the minimum required dimension for the high jump landing foam bed."
  },
  {
    id: 19,
    category: "Pole Vault",
    text: "In international competition, the pole vault landing area must be at least:",
    options: [
      "5 m × 5 m × 0.8 m",
      "6 m × 6 m × 0.8 m",
      "6 m × 5 m × 0.7 m",
      "9 m × 3 m × 0.5 m"
    ],
    correctOption: 1,
    explanation: "6 m × 6 m × 0.8 m is the minimum official pole vault landing area specification."
  },
  {
    id: 20,
    category: "Pole Vault",
    text: "In pole vault, when 3 or fewer athletes remain, how much time does each athlete get for a trial?",
    options: ["1 minute", "90 seconds", "2 minutes", "3 minutes"],
    correctOption: 2,
    explanation: "2 minutes per trial when 2 or 3 athletes remain."
  },
  {
    id: 21,
    category: "Pole Vault",
    text: "Which statement about pole vault is correct?",
    options: [
      "Gloves are not permitted",
      "Taping of the hands and fingers is freely allowed",
      "Gloves are permitted, and taping of the wrist is allowed",
      "Athletes must use poles provided by the organisers"
    ],
    correctOption: 2,
    explanation: "Gloves are permitted, and taping of the wrist is allowed."
  },
  {
    id: 22,
    category: "Pole Vault",
    text: "In a pole vault tie, the first deciding criterion is:",
    options: [
      "The athlete with the fewest jumps at the height last cleared",
      "The athlete with the lighter body weight",
      "The athlete who started at the higher height",
      "A coin toss"
    ],
    correctOption: 0,
    explanation: "The athlete with the fewest jumps at the height last cleared."
  },
  {
    id: 23,
    category: "Shot Put",
    text: "What is the diameter of the shot put circle?",
    options: ["2.00 m", "2.135 m", "2.50 m", "2.75 m"],
    correctOption: 1,
    explanation: "2.135 m (7 feet) inner diameter."
  },
  {
    id: 24,
    category: "Shot Put",
    text: "What is the weight of the men's shot?",
    options: ["6.00 kg", "7.000 kg", "7.260 kg", "8.000 kg"],
    correctOption: 2,
    explanation: "7.260 kg (16 lbs) for senior men."
  },
  {
    id: 25,
    category: "Shot Put",
    text: "The Parry O'Brien style of shot put is also known as the:",
    options: ["Simple method", "Glide method", "Rotatory method", "Standing method"],
    correctOption: 1,
    explanation: "Glide method – invented by Parry O'Brien."
  },
  {
    id: 26,
    category: "Shot Put",
    text: "If the shot lands on one of the sector lines:",
    options: [
      "It is measured normally",
      "A re-throw is given",
      "It is called a foul and not measured",
      "Half the distance is recorded"
    ],
    correctOption: 2,
    explanation: "It is called a foul and not measured."
  },
  {
    id: 27,
    category: "Throwing Events",
    text: "What is the sector angle for shot put, discus and hammer throw?",
    options: ["28.96°", "29°", "34.92°", "40°"],
    correctOption: 2,
    explanation: "34.92° is the standardized landing sector angle for shot, discus, and hammer."
  },
  {
    id: 28,
    category: "Discus Throw",
    text: "What is the diameter of the discus throwing circle?",
    options: ["2.135 m", "2.50 m", "2.75 m", "3.00 m"],
    correctOption: 1,
    explanation: "2.50 m inner diameter."
  },
  {
    id: 29,
    category: "Discus Throw",
    text: "What is the weight of the women's discus?",
    options: ["0.75 kg", "1 kg", "1.5 kg", "2 kg"],
    correctOption: 1,
    explanation: "1 kg for senior women's competition."
  },
  {
    id: 30,
    category: "Discus Throw",
    text: "Two discus throwers finish with the same best distance. The tie is broken by:",
    options: [
      "An extra throw",
      "Comparing their second-best performances",
      "The athlete who achieved the distance first",
      "Averaging all throws"
    ],
    correctOption: 1,
    explanation: "Comparing their second-best performances."
  },
  {
    id: 31,
    category: "Javelin Throw",
    text: "What is the weight of the men's javelin?",
    options: ["600 g", "700 g", "800 g", "900 g"],
    correctOption: 2,
    explanation: "800 g for senior men."
  },
  {
    id: 32,
    category: "Javelin Throw",
    text: "What is the javelin throwing sector angle?",
    options: ["28.96°", "30°", "34.92°", "36.5°"],
    correctOption: 0,
    explanation: "28.96° – About 29°."
  },
  {
    id: 33,
    category: "Javelin Throw",
    text: "A javelin throw is valid only if:",
    options: [
      "The tail touches the ground first",
      "The metal head strikes the ground before any other part",
      "It lands flat",
      "It crosses the 30 m line"
    ],
    correctOption: 1,
    explanation: "The metal head strikes the ground before any other part."
  },
  {
    id: 34,
    category: "Javelin Throw",
    text: "In javelin, a yellow flag is raised to indicate:",
    options: [
      "A foul throw",
      "The final 15 seconds of the allowed time",
      "A broken javelin",
      "A wind reading above the limit"
    ],
    correctOption: 1,
    explanation: "The final 15 seconds of the allowed time."
  },
  {
    id: 35,
    category: "Javelin Throw",
    text: "Which grip is NOT one of the javelin grips listed in the material?",
    options: ["Finnish grip", "American grip", "Polish grip", "Orthodox grip"],
    correctOption: 3,
    explanation: "Orthodox grip – recognized grips are American, Finnish, and Polish (Fork/V-grip)."
  },
  {
    id: 36,
    category: "Hammer Throw",
    text: "In which throwing event are gloves allowed?",
    options: ["Shot put", "Discus", "Javelin", "Hammer throw"],
    correctOption: 3,
    explanation: "Hammer throw."
  },
  {
    id: 37,
    category: "Hammer Throw",
    text: "The hammer cage must be able to stop a 7.260 kg hammer head moving at up to:",
    options: ["25 m/s", "28 m/s", "32 m/s", "40 m/s"],
    correctOption: 2,
    explanation: "32 m/s."
  },
  {
    id: 38,
    category: "Hammer Throw",
    text: "What is the maximum mesh size for the cord netting of a hammer cage?",
    options: ["40 mm", "45 mm", "50 mm", "55 mm"],
    correctOption: 1,
    explanation: "45 mm – The limit for steel wire netting is 50 mm."
  },
  {
    id: 39,
    category: "Yoga",
    text: "The word \"Yoga\" comes from the Sanskrit root \"Yuj\", which means:",
    options: ["To breathe", "To meditate", "To join or unite", "To stretch"],
    correctOption: 2,
    explanation: "To join or unite."
  },
  {
    id: 40,
    category: "Yoga",
    text: "Which type of yoga is the path of action without attachment to the outcome?",
    options: ["Gyan Yoga", "Bhakti Yoga", "Karma Yoga", "Mantra Yoga"],
    correctOption: 2,
    explanation: "Karma Yoga is the path of selfless action without attachment to the results."
  },
  {
    id: 41,
    category: "Yoga",
    text: "Who equated Raja Yoga with the Yoga Sutras of Patanjali?",
    options: ["Maharishi Patanjali", "Swami Vivekananda", "Swami Ramdev", "B.K.S. Iyengar"],
    correctOption: 1,
    explanation: "Swami Vivekananda equated Raja Yoga with the Yoga Sutras in his influential 1896 treatise."
  },
  {
    id: 42,
    category: "Yoga",
    text: "Which form of yoga is also called Kundalini Yoga?",
    options: ["Laya Yoga", "Hatha Yoga", "Yantra Yoga", "Tantra Yoga"],
    correctOption: 0,
    explanation: "Laya Yoga is also known as Kundalini Yoga."
  },
  {
    id: 43,
    category: "Ashtanga Yoga",
    text: "What is the 5th limb of Ashtanga Yoga?",
    options: ["Pranayama", "Dharana", "Pratyahara", "Dhyana"],
    correctOption: 2,
    explanation: "Pratyahara – Withdrawal of the senses."
  },
  {
    id: 44,
    category: "Ashtanga Yoga",
    text: "\"Asteya\" (non-stealing) falls under which limb?",
    options: ["Niyama", "Yama", "Asana", "Samadhi"],
    correctOption: 1,
    explanation: "Yama includes Ahimsa, Satya, Asteya, Brahmacharya, and Aparigraha."
  },
  {
    id: 45,
    category: "Ashtanga Yoga",
    text: "Which of the following is a Niyama?",
    options: ["Satya", "Ahimsa", "Svadhyaya", "Aparigraha"],
    correctOption: 2,
    explanation: "Svadhyaya – Self-study (along with Saucha, Santosha, Tapas, Ishvara Pranidhana)."
  },
  {
    id: 46,
    category: "Ashtanga Yoga",
    text: "The root of the word \"Dharana\" is \"dhri\", which means:",
    options: ["To breathe", "To hold or maintain", "To withdraw", "To dissolve"],
    correctOption: 1,
    explanation: "To hold or maintain."
  },
  {
    id: 47,
    category: "Nutrition",
    text: "What is the ratio of Carbon : Hydrogen : Oxygen in carbohydrates?",
    options: ["1:1:1", "1:2:1", "2:1:1", "1:2:2"],
    correctOption: 1,
    explanation: "1:2:1 – from empirical chemical formula (CH2O)n."
  },
  {
    id: 48,
    category: "Nutrition",
    text: "How much energy does 1 g of fat give?",
    options: ["4.1 kcal", "7.1 kcal", "9.1 kcal", "12 kcal"],
    correctOption: 2,
    explanation: "9.1 kcal per gram of fat."
  },
  {
    id: 49,
    category: "Nutrition",
    text: "Lactose (milk sugar) is made of:",
    options: [
      "Glucose + Glucose",
      "Glucose + Fructose",
      "Glucose + Galactose",
      "Fructose + Galactose"
    ],
    correctOption: 2,
    explanation: "Glucose + Galactose."
  },
  {
    id: 50,
    category: "Nutrition",
    text: "Kwashiorkor and Marasmus are caused by a deficiency of:",
    options: ["Carbohydrates", "Fat", "Protein", "Vitamins"],
    correctOption: 2,
    explanation: "Protein deficiency causes Kwashiorkor and severe Protein-Energy malnutrition causes Marasmus."
  }
];


export const FINAL_EXAM_SET2_50_QUESTIONS: ExamQuestion[] = [
  {
    "id": 1,
    "category": "Weightlifting",
    "text": "Women's weightlifting was first included in the Olympics at:",
    "options": [
      "1996 Atlanta",
      "2000 Sydney",
      "2004 Athens",
      "1920 Antwerp"
    ],
    "correctOption": 1,
    "explanation": "Women's weightlifting made its Olympic debut at the 2000 Sydney Olympic Games."
  },
  {
    "id": 2,
    "category": "Weightlifting",
    "text": "Where is the headquarters of the International Weightlifting Federation (IWF)?",
    "options": [
      "Lausanne, Switzerland",
      "Geneva, Switzerland",
      "Budapest, Hungary",
      "New Delhi, India"
    ],
    "correctOption": 0,
    "explanation": "The International Weightlifting Federation (IWF) is headquartered in Lausanne, Switzerland."
  },
  {
    "id": 3,
    "category": "Weightlifting",
    "text": "What is the weight of the competition bar used by women lifters?",
    "options": [
      "10 kg",
      "15 kg",
      "20 kg",
      "25 kg"
    ],
    "correctOption": 1,
    "explanation": "The standard women's competition bar weighs 15 kg (the men's bar weighs 20 kg)."
  },
  {
    "id": 4,
    "category": "Weightlifting",
    "text": "A large RED weight disc weighs:",
    "options": [
      "20 kg",
      "15 kg",
      "25 kg",
      "10 kg"
    ],
    "correctOption": 2,
    "explanation": "According to IWF standards, large Red discs weigh 25 kg, Blue 20 kg, Yellow 15 kg, Green 10 kg, and White 5 kg."
  },
  {
    "id": 5,
    "category": "Weightlifting",
    "text": "Each barbell has two collars. What does each collar weigh?",
    "options": [
      "1 kg",
      "1.5 kg",
      "2 kg",
      "2.5 kg"
    ],
    "correctOption": 3,
    "explanation": "Each standard competition collar weighs exactly 2.5 kg, adding a total of 5 kg to the barbell assembly."
  },
  {
    "id": 6,
    "category": "Weightlifting",
    "text": "The dimensions of a weightlifting competition platform are:",
    "options": [
      "3 m x 3 m, 5 cm high",
      "4 m x 4 m, 10 cm high",
      "4 m x 4 m, 15 cm high",
      "5 m x 5 m, 10 cm high"
    ],
    "correctOption": 1,
    "explanation": "The official weightlifting platform measures 4 m x 4 m square with a height of 10 cm."
  },
  {
    "id": 7,
    "category": "Weightlifting",
    "text": "Which of these may a lifter use to improve grip?",
    "options": [
      "Talcum",
      "Oil",
      "Water",
      "Chalk (magnesium carbonate)"
    ],
    "correctOption": 3,
    "explanation": "Lifters may only apply chalk (magnesium carbonate) on their hands. Grease, oil, water, and talcum are strictly prohibited."
  },
  {
    "id": 8,
    "category": "Weightlifting",
    "text": "Which of the following is declared a 'No Lift'?",
    "options": [
      "Using chalk on the hands",
      "Lowering the bar in front of the body after the signal",
      "Touching the platform with a knee during the lift",
      "Facing the centre referee at the start"
    ],
    "correctOption": 2,
    "explanation": "Touching the platform with any part of the body other than the feet (such as a knee) constitutes a foul and is declared a 'No Lift'."
  },
  {
    "id": 9,
    "category": "Kabaddi",
    "text": "Men's kabaddi was first included in the Asian Games in:",
    "options": [
      "1982 New Delhi",
      "1990 Beijing",
      "1994 Hiroshima",
      "2010 Guangzhou"
    ],
    "correctOption": 1,
    "explanation": "Men's kabaddi was officially included in the Asian Games for the first time at Beijing 1990."
  },
  {
    "id": 10,
    "category": "Kabaddi",
    "text": "Women's kabaddi was first included in the Asian Games in:",
    "options": [
      "1990 Beijing",
      "2002 Busan",
      "2006 Doha",
      "2010 Guangzhou"
    ],
    "correctOption": 3,
    "explanation": "Women's kabaddi was introduced to the Asian Games at Guangzhou 2010."
  },
  {
    "id": 11,
    "category": "Kabaddi",
    "text": "Who received the first Arjuna Award for kabaddi (1972)?",
    "options": [
      "E. Prasad Rao",
      "Sudhir Parab",
      "Sadanand Shetty",
      "Prithipal Singh"
    ],
    "correctOption": 2,
    "explanation": "Sadanand Shetty received the first Arjuna Award for Kabaddi in 1972. E. Prasad Rao was the first Dronacharya awardee in 2002."
  },
  {
    "id": 12,
    "category": "Kabaddi",
    "text": "What is the size of the kabaddi court for Men and Junior Boys?",
    "options": [
      "13 m x 10 m",
      "12 m x 8 m",
      "13 m x 8 m",
      "12 m x 10 m"
    ],
    "correctOption": 0,
    "explanation": "The official kabaddi court dimension for Men and Junior Boys is 13 m x 10 m (for Women and Junior Girls, it is 12 m x 8 m)."
  },
  {
    "id": 13,
    "category": "Kabaddi",
    "text": "What is the match duration for women's kabaddi?",
    "options": [
      "20-5-20 minutes",
      "15-5-15 minutes",
      "20-10-20 minutes",
      "15-10-15 minutes"
    ],
    "correctOption": 1,
    "explanation": "The match duration for women's kabaddi is 15-5-15 minutes (two halves of 15 minutes with a 5-minute break), whereas men play 20-5-20."
  },
  {
    "id": 14,
    "category": "Kabaddi",
    "text": "How many extra points are awarded to a team for a LONA?",
    "options": [
      "3",
      "1",
      "4",
      "2"
    ],
    "correctOption": 3,
    "explanation": "When an entire opposing team is put out, a LONA is scored, awarding 2 additional bonus points."
  },
  {
    "id": 15,
    "category": "Kabaddi",
    "text": "The bonus line applies only when the defending side has at least how many players on court?",
    "options": [
      "4",
      "5",
      "6",
      "7"
    ],
    "correctOption": 2,
    "explanation": "The bonus line is active only when there are at least 6 defenders present on the court (6 or 7 defenders)."
  },
  {
    "id": 16,
    "category": "Kabaddi",
    "text": "What is the time limit for each raid?",
    "options": [
      "30 seconds",
      "20 seconds",
      "45 seconds",
      "60 seconds"
    ],
    "correctOption": 0,
    "explanation": "The maximum duration permitted for each raid in competitive kabaddi is exactly 30 seconds."
  },
  {
    "id": 17,
    "category": "Kabaddi",
    "text": "In kabaddi, a YELLOW card means:",
    "options": [
      "A warning only",
      "Temporary suspension for 2 minutes",
      "Suspension from the match",
      "One technical point to the opponent"
    ],
    "correctOption": 1,
    "explanation": "In kabaddi: Green Card = Warning; Yellow Card = Temporary suspension for 2 minutes; Red Card = Suspension from match/tournament."
  },
  {
    "id": 18,
    "category": "Kho-Kho",
    "text": "The Kho-Kho Federation of India was established in:",
    "options": [
      "1960",
      "1987",
      "1955",
      "1950"
    ],
    "correctOption": 2,
    "explanation": "The Kho-Kho Federation of India (KKFI) was founded in the year 1955, with headquarters in New Delhi."
  },
  {
    "id": 19,
    "category": "Kho-Kho",
    "text": "What is the distance from post to post in a kho-kho court?",
    "options": [
      "24 m",
      "27 m",
      "16 m",
      "30 m"
    ],
    "correctOption": 0,
    "explanation": "The distance between the two wooden posts in a standard Kho-Kho playing field is 24 meters."
  },
  {
    "id": 20,
    "category": "Kho-Kho",
    "text": "A kho-kho team has 12 players. How many of them play on the field?",
    "options": [
      "7",
      "9",
      "11",
      "12"
    ],
    "correctOption": 1,
    "explanation": "A Kho-Kho team consists of 12 players in total, out of which 9 players take the field at a time."
  },
  {
    "id": 21,
    "category": "Kho-Kho",
    "text": "The size of each cross lane in a kho-kho court is:",
    "options": [
      "16 m x 30 cm",
      "24 m x 30 cm",
      "16 m x 35 cm",
      "27 m x 35 cm"
    ],
    "correctOption": 2,
    "explanation": "Each cross lane in a standard Kho-Kho court measures 16 m in length by 35 cm in width (the central lane is 24 m x 30 cm)."
  },
  {
    "id": 22,
    "category": "Kho-Kho",
    "text": "What is the height of a kho-kho post above the ground?",
    "options": [
      "130-135 cm",
      "110-115 cm",
      "100-110 cm",
      "120-125 cm"
    ],
    "correctOption": 3,
    "explanation": "The Kho-Kho wooden post extends 120-125 cm above ground level with a diameter of 9-10 cm."
  },
  {
    "id": 23,
    "category": "Kho-Kho",
    "text": "Who received the first Arjuna Award for kho-kho (1970)?",
    "options": [
      "Gopal Purushottam Phadke",
      "Sudhir Bhaskarrao Parab",
      "Sadanand Shetty",
      "Gurdayal Singh Bhangu"
    ],
    "correctOption": 1,
    "explanation": "Sudhir Bhaskarrao Parab was awarded the first Arjuna Award for Kho-Kho in 1970 (G.P. Phadke received the Dronacharya award in 2000)."
  },
  {
    "id": 24,
    "category": "Kho-Kho",
    "text": "If a defender touches a chaser for the first time in a turn, he is:",
    "options": [
      "Declared out",
      "Shown a yellow card",
      "Warned once verbally",
      "Penalised with a point to the chasers"
    ],
    "correctOption": 2,
    "explanation": "If a defender accidentally touches a chaser for the first time in a turn, he is given a verbal warning by the referee; repetition results in being declared out."
  },
  {
    "id": 25,
    "category": "Kho-Kho",
    "text": "The Asian Kho-Kho Federation (AKKF) was formed in:",
    "options": [
      "1987",
      "1996",
      "1955",
      "1982"
    ],
    "correctOption": 0,
    "explanation": "The Asian Kho-Kho Federation (AKKF) was formally established in 1987 during the 3rd South Asian Games."
  },
  {
    "id": 26,
    "category": "Hockey",
    "text": "The International Hockey Federation (FIH) was founded on:",
    "options": [
      "1886, London",
      "1927, Paris",
      "1924, Lausanne",
      "7 January 1924, Brussels"
    ],
    "correctOption": 3,
    "explanation": "The International Hockey Federation (FIH) was founded on 7 January 1924 in Brussels, Belgium (now headquartered in Lausanne)."
  },
  {
    "id": 27,
    "category": "Hockey",
    "text": "The first international hockey match (26 January 1895, Rhyl) was played between:",
    "options": [
      "Wales and Ireland",
      "England and Scotland",
      "England and Ireland",
      "Wales and England"
    ],
    "correctOption": 0,
    "explanation": "The first international field hockey match took place on 26 January 1895 at Rhyl between Wales and Ireland."
  },
  {
    "id": 28,
    "category": "Hockey",
    "text": "The standard size of a field hockey pitch is:",
    "options": [
      "110 yd x 70 yd",
      "100 yd x 60 yd",
      "100 yd x 55 yd",
      "91 yd x 60 yd"
    ],
    "correctOption": 1,
    "explanation": "A standard field hockey pitch measures 100 yards x 60 yards (91.40 m x 55.00 m)."
  },
  {
    "id": 29,
    "category": "Hockey",
    "text": "How far from the goal line is the shooting circle ('D') marked?",
    "options": [
      "7 yards",
      "25 yards",
      "16 yards (14.63 m)",
      "12 feet"
    ],
    "correctOption": 2,
    "explanation": "The shooting circle ('D') line is drawn 16 yards (14.63 meters) from each goal post."
  },
  {
    "id": 30,
    "category": "Hockey",
    "text": "The hockey goal measures:",
    "options": [
      "12 ft wide x 7 ft high",
      "7.32 m wide x 2.44 m high",
      "3 m wide x 2 m high",
      "12 ft wide x 8 ft high"
    ],
    "correctOption": 0,
    "explanation": "The field hockey goal dimensions are 12 feet wide by 7 feet high (3.66 m x 2.14 m)."
  },
  {
    "id": 31,
    "category": "Hockey",
    "text": "Women's hockey was first played at the Olympics in:",
    "options": [
      "1908 London",
      "1980 Moscow",
      "1928 Amsterdam",
      "1982 New Delhi"
    ],
    "correctOption": 1,
    "explanation": "Women's field hockey was introduced to the Olympic Games at the 1980 Moscow Olympics (Men's in 1908 London)."
  },
  {
    "id": 32,
    "category": "Hockey",
    "text": "Where was the first men's Hockey World Cup held?",
    "options": [
      "1975, Kuala Lumpur",
      "1974, France",
      "1982, New Delhi",
      "1971, Barcelona"
    ],
    "correctOption": 3,
    "explanation": "The inaugural men's FIH Hockey World Cup was held in Barcelona, Spain in 1971 (Pakistan were champions)."
  },
  {
    "id": 33,
    "category": "Hockey",
    "text": "How many Olympic gold medals has the Indian men's hockey team won?",
    "options": [
      "6",
      "7",
      "8",
      "9"
    ],
    "correctOption": 2,
    "explanation": "The Indian men's hockey team has won a historic total of 8 Olympic gold medals (1928, 1932, 1936, 1948, 1952, 1956, 1964, 1980)."
  },
  {
    "id": 34,
    "category": "Hockey",
    "text": "In field hockey, a YELLOW card means the player is:",
    "options": [
      "Off for about 2 minutes",
      "Off for about 5 minutes and cannot be replaced",
      "Expelled for the rest of the match",
      "Given a verbal warning only"
    ],
    "correctOption": 1,
    "explanation": "In field hockey, a Yellow card indicates temporary suspension of a minimum of 5 minutes during which the player cannot be substituted."
  },
  {
    "id": 35,
    "category": "Handball",
    "text": "Handball was officially included in the Olympics for the first time at:",
    "options": [
      "1972, Munich",
      "1928, Amsterdam",
      "1952, Helsinki",
      "1936, Berlin"
    ],
    "correctOption": 3,
    "explanation": "Field handball was officially included as an Olympic sport for the first time at Berlin 1936 (modern indoor handball was reintroduced at Munich 1972)."
  },
  {
    "id": 36,
    "category": "Handball",
    "text": "The International Handball Federation (IHF) was established in:",
    "options": [
      "1928",
      "1936",
      "1946",
      "1974"
    ],
    "correctOption": 2,
    "explanation": "The International Handball Federation (IHF) was founded on 11 July 1946 in Copenhagen/Basel."
  },
  {
    "id": 37,
    "category": "Handball",
    "text": "The Handball Federation of India (HFI) was founded on:",
    "options": [
      "15 June 1972, Rohtak (Haryana)",
      "1974, Kuwait City",
      "1982, New Delhi",
      "1946, Indore"
    ],
    "correctOption": 0,
    "explanation": "The Handball Federation of India (HFI) was founded on 15 June 1972 at Rohtak (Haryana) by Jagat Singh Lohan."
  },
  {
    "id": 38,
    "category": "Handball",
    "text": "The handball goal measures:",
    "options": [
      "3.66 m wide x 2.14 m high",
      "3 m wide x 2 m high",
      "2 m wide x 3 m high",
      "5 m wide x 2 m high"
    ],
    "correctOption": 1,
    "explanation": "The official handball goal dimensions are 3 meters wide by 2 meters high with a 28 cm deep frame."
  },
  {
    "id": 39,
    "category": "Handball",
    "text": "Only the goalkeeper is allowed inside the goal area. This area is marked by a line at:",
    "options": [
      "9 m",
      "7 m",
      "3 m",
      "6 m"
    ],
    "correctOption": 3,
    "explanation": "The exclusive goal area (crease) is defined by the 6-meter semi-circular line. Penalty throws are taken from the 7-meter line."
  },
  {
    "id": 40,
    "category": "Handball",
    "text": "'Walking' is called when a player without dribbling takes more than:",
    "options": [
      "3 steps, or holds the ball over 3 seconds",
      "2 steps, or holds the ball over 5 seconds",
      "4 steps, or holds the ball over 3 seconds",
      "3 steps, or holds the ball over 5 seconds"
    ],
    "correctOption": 0,
    "explanation": "Under IHF rules, a player without dribbling may take a maximum of 3 steps and hold the ball for at most 3 seconds."
  },
  {
    "id": 41,
    "category": "Handball",
    "text": "What is the match duration for players over 16 years?",
    "options": [
      "25-10-25 minutes",
      "20-10-20 minutes",
      "30-10-30 minutes",
      "35-5-35 minutes"
    ],
    "correctOption": 2,
    "explanation": "Official handball matches for adult and senior players (over 16 years) consist of two 30-minute halves (30-10-30 minutes)."
  },
  {
    "id": 42,
    "category": "Handball",
    "text": "During a throw-off, opponents must stay at least how far from the thrower?",
    "options": [
      "6 m",
      "3 m",
      "1.5 m",
      "9 m"
    ],
    "correctOption": 1,
    "explanation": "During a throw-off (or throw-in/free throw), defending opponents must remain at least 3 meters away from the executor."
  },
  {
    "id": 43,
    "category": "Chess",
    "text": "What is the ancient Indian name of chess?",
    "options": [
      "Shatranj",
      "Chaturanga",
      "Pachisi",
      "Chaupar"
    ],
    "correctOption": 1,
    "explanation": "The ancient Indian predecessor of chess is 'Chaturanga', which developed in northern India during the Gupta Empire."
  },
  {
    "id": 44,
    "category": "Chess",
    "text": "FIDE (World Chess Federation) was founded in:",
    "options": [
      "1951",
      "1927",
      "1924",
      "1957"
    ],
    "correctOption": 2,
    "explanation": "FIDE (Fédération Internationale des Échecs) was founded on 20 July 1924 in Paris, France."
  },
  {
    "id": 45,
    "category": "Chess",
    "text": "Who became India's first Grandmaster in 1988?",
    "options": [
      "Manuel Aaron",
      "Dibyendu Barua",
      "Pravin Thipsay",
      "Viswanathan Anand"
    ],
    "correctOption": 3,
    "explanation": "Viswanathan Anand became India's first Grandmaster in 1988 at the age of 18."
  },
  {
    "id": 46,
    "category": "Chess",
    "text": "Who received the first Arjuna Award for chess (1961)?",
    "options": [
      "Manuel Aaron",
      "Viswanathan Anand",
      "S. Vijayalakshmi",
      "Raghunandan Gokhale"
    ],
    "correctOption": 0,
    "explanation": "Manuel Aaron was honored with the first Arjuna Award for chess in 1961 (India's first International Master)."
  },
  {
    "id": 47,
    "category": "Chess",
    "text": "What is the point value of a rook?",
    "options": [
      "3",
      "5",
      "9",
      "1"
    ],
    "correctOption": 1,
    "explanation": "In chess standard piece valuation: Queen = 9, Rook = 5, Bishop = 3, Knight = 3, Pawn = 1."
  },
  {
    "id": 48,
    "category": "Chess",
    "text": "Which player makes the first move in a chess game?",
    "options": [
      "The player with white pieces",
      "The player with black pieces",
      "Whoever wins the toss",
      "The arbiter decides"
    ],
    "correctOption": 0,
    "explanation": "By official chess rules, the player who controls the white pieces always makes the opening move."
  },
  {
    "id": 49,
    "category": "Chess",
    "text": "A game ends in 'stalemate' when the player to move:",
    "options": [
      "Is in check and has no legal move",
      "Has repeated the same position three times",
      "Has no legal move and the king is not in check",
      "Has made 50 moves without a capture"
    ],
    "correctOption": 2,
    "explanation": "Stalemate occurs when the player whose turn it is has no legal move and their king is NOT in check, resulting in an immediate draw."
  },
  {
    "id": 50,
    "category": "Chess",
    "text": "A game may be drawn if each player makes the last ___ consecutive moves with no pawn move and no capture.",
    "options": [
      "40",
      "75",
      "100",
      "50"
    ],
    "correctOption": 3,
    "explanation": "The official Fifty-Move Rule states that a player can claim a draw if the last 50 consecutive moves have been made without any pawn move or piece capture."
  }
];

export const EXAM_SCHEDULES: Record<string, ExamScheduleConfig> = {
  mock_test_1: {
    id: 'mock_test_1',
    title: 'Phase 2 Practice Mock Examination 1',
    subtitle: 'Track & Field, Sports Nutrition, Ashtanga Yoga & Athletics Protocols',
    targetDate: '2026-10-17',
    dateDisplay: 'Saturday, 17 October 2026',
    loginOpenTime: '20:00',
    loginCloseTime: '20:15',
    examStartTime: '20:15',
    examEndTime: '21:00',
    durationMinutes: 45,
    totalQuestions: 30,
    marksPerQuestion: 1,
    passingScore: 15,
    questions: MOCK_TEST_1_QUESTIONS,
  },
  mock_test_2: {
    id: 'mock_test_2',
    title: 'Phase 2 Practice Mock Examination 2',
    subtitle: 'Throws, Jumps, Technical Measurements & Physical Training Standards',
    targetDate: '2026-10-18',
    dateDisplay: 'Sunday Morning, 18 October 2026',
    loginOpenTime: '08:00',
    loginCloseTime: '08:15',
    examStartTime: '08:15',
    examEndTime: '09:00',
    durationMinutes: 45,
    totalQuestions: 30,
    marksPerQuestion: 1,
    passingScore: 15,
    questions: MOCK_TEST_2_QUESTIONS,
  },
  final_exam: {
    id: 'final_exam',
    title: 'Kreed Odisha Official Evaluation Examination',
    subtitle: 'Unified Examination (All Candidates & Batches) • Track & Field, Jumps, Throws, Ashtanga Yoga & Sports Nutrition',
    targetDate: '2026-10-18',
    dateDisplay: 'Today • Sunday, 18 October 2026',
    loginOpenTime: '13:00',
    loginCloseTime: '13:15',
    examStartTime: '13:15',
    examEndTime: '14:00',
    durationMinutes: 45,
    totalQuestions: 30,
    marksPerQuestion: 1,
    passingScore: 15,
    isTeacherProvided: false,
    questions: FINAL_EXAM_50_QUESTIONS,
  },
  final_exam_set2: {
    id: 'final_exam_set2',
    title: 'Kreed Odisha Training Assessment (MCQ Set 2)',
    subtitle: 'Unified Examination (All Candidates & Batches) • Weightlifting, Kabaddi, Kho-Kho, Hockey, Handball & Chess',
    targetDate: '2026-11-03',
    dateDisplay: 'Today (Tuesday, 3 Nov 2026) • 1:15 PM – 2:00 PM IST (Lobby Opens 1:00 PM)',
    loginOpenTime: '13:00',
    loginCloseTime: '13:15',
    examStartTime: '13:15',
    examEndTime: '14:00',
    durationMinutes: 45,
    totalQuestions: 30,
    marksPerQuestion: 1,
    passingScore: 15,
    isTeacherProvided: true,
    isCancelled: false,
    questions: FINAL_EXAM_SET2_50_QUESTIONS,
  },
};

